import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSiteDetail,
  unloadSiteDetail
} from "../../redux/actions/asset.actions";
import EventList from "../../components/EventList";
import AssetList from "../../components/AssetList";
import CampaignList from "../../components/CampaignList";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import Graph from "../../components/widgets/Graph";
import GoogleMapReact from "google-map-react";
import * as DateHelper from "../../utils/date.formatter";
import { REACT_APP_MODE } from "../../config";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

export default function() {
  let { key } = useParams();
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSiteDetail(key));
    return () => dispatch(unloadSiteDetail());
  }, [key]);

  if (!asset.site) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"sites"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  const lat = parseInt(asset.site.latitude * 1000000) / 1000000;
  const lng = parseInt(asset.site.longitude * 1000000) / 1000000;

  const temp_events = asset.events
    ? asset.events.filter(i => i.type === "TEMPERATURE")
    : [];

  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"sites"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/sites/${asset.site.key}/edit`}
                >
                  {t("system.edit_button")}
                </Link>
                <h2>
                  <Link to="/sites">{t("common.sites")}</Link> &gt;{" "}
                  {asset.site.name}
                </h2>
              </div>
              <ul className="dashboard-list">
                <li>
                  <strong>{t("common.assets")}</strong>
                  <em>{asset.assets_total}</em>
                </li>
                <li>
                  <strong>{t("common.events")}</strong>
                  <em>{asset.events_total}</em>
                </li>
                <li>
                  <strong>{t("common.created")}</strong>
                  <em>{DateHelper.toLocalDateString(asset.site.created)}</em>
                </li>
              </ul>
              <div className="map-box">
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyChP3vkShVB0f9F_pWR-f9RoevDAuY5lPQ"
                  }}
                  defaultCenter={{ lat: lat, lng: lng }}
                  defaultZoom={11}
                >
                  <img className="map-pin" src="/pin.png" lat={lat} lng={lng} />
                </GoogleMapReact>
              </div>
              <Graph data={temp_events} />
              {asset.site.notes ? (
                <div className="note-box">
                  <strong>{t("site.label_notes")}:</strong> {asset.site.notes}
                </div>
              ) : (
                ""
              )}
            </div>

            {asset.campaigns && asset.campaigns.length > 0 ? (
              <div className="content-wrap content-wrap-middle">
                <div className="box-header">
                  <Link
                    className="header-button"
                    to={`/campaigns/add?from=site&key=${asset.site.key}`}
                  >
                    {t("campaign.create_button")}
                  </Link>
                  <h2>{t("common.campaigns")}</h2>
                </div>
                <CampaignList data={asset.campaigns} />
              </div>
            ) : (
              ""
            )}

            <div className="content-wrap-clear">
              <div className="content-wrap content-wrap-narrow">
                <div className="box-header">
                  <Link
                    className="header-button"
                    to={`/events/add?from=site&sitekey=${asset.site.key}`}
                  >
                    {t("event.create_button")}
                  </Link>
                  <h2>{t("event.label_recent_events")}</h2>
                </div>
                <EventList data={asset.events} mode="small" />
              </div>
              <div className="content-wrap content-wrap-narrow content-wrap-last">
                <div className="box-header">
                  <Link
                    className="header-button"
                    to={`/assets/add?from=site&key=${asset.site.key}`}
                  >
                    {t("asset.create_button")}
                  </Link>
                  <h2>{t("asset.label_recent_assets")}</h2>
                </div>
                <AssetList data={asset.assets} mode="small" />
              </div>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}
